import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateProfileService {

  constructor() { }

    private subject = new Subject<any>();
    
    sendClickEvent(message: string) {
      this.subject.next(message);
    }
    getClickEvent(): Observable<any>{ 
      return this.subject.asObservable();
    }
}
